import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { CustomizeViews } from '~/features/customize/os/customize-views';

/** `by=hand` opens the one list and one sheet (stage 5); without it Customize opens with OS first (board customize-os). */
const search = z.object({ by: z.enum(['hand']).optional() });

function CustomizeRoute(): ReactElement {
  const { by } = Route.useSearch();
  const navigate = Route.useNavigate();
  return <CustomizeViews by={by ?? null} onBy={(next) => void navigate({ search: next === null ? {} : { by: next } })} />;
}

export const Route = createFileRoute('/_app/records/$recordId/customize/')({
  validateSearch: search,
  component: CustomizeRoute,
});
